var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"main-layout-section"},[(_vm.getPreloaderState)?_c('Preloader'):_vm._e(),_c('Header'),(_vm.isBasicInfoLoaded)?_c('div',{staticClass:"view-content mobile-first-layout"},[_c('router-view')],1):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }